export class PrintingEvents {
  static setPrintSetupRequest = 'setPrintSetupRequest';
  static printLabelsRequest = 'printLabelsRequest';
  static printLabelsResponse = 'printLabelsResponse';
  static printReceiptsRequest = 'printReceiptsRequest';
  static printReceiptsResponse = 'printReceiptsResponse';
  static pausePrinterRequest = 'pausePrinterRequest';
  static purgeQueueRequest = 'purgeQueueRequest';
  static resumePrinterRequest = 'resumePrinterRequest';
  static sendCommandStringRequest = 'sendCommandStringRequest';
};
